import axios, { AxiosError, AxiosResponse } from "axios";

const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosConfig.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);
const handleResponseSuccess = (response: AxiosResponse) => {
  const body: any = {
    status: response?.status,
    data: response?.data,
  };

  return body;
};
const handleResponseFail = (error: any) => {
  const errCustom: any = {
    status: error?.response?.status,
    message: error?.response?.data["response.message"],
  };
  return Promise.reject(errCustom);
};
axiosConfig.interceptors.response.use(
  handleResponseSuccess,
  handleResponseFail
);

export default axiosConfig;
